import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Product Locations
 */
@Component
export class ProductLocations extends ThemeComponent {
    @Ref locationTriggers!: HTMLButtonElement[];
    @Ref locationContents!: HTMLDivElement[];

    protected activeTrigger: HTMLButtonElement|undefined|null = null;
    protected activeContent: HTMLDivElement|undefined|null = null;

    init() {
        this.activeTrigger = this.locationTriggers.find(
            (locationTrigger) => locationTrigger.classList.contains('active-trigger')
        );

        for (const locationTrigger of this.locationTriggers) {

            this.$listen(locationTrigger, 'click', (event) => {
                this.onTriggerClick(event);
            });
        }

        this.activeContent = this.locationContents.find(
            (locationContent) => locationContent.classList.contains('active-location')
        );

    }

    onTriggerClick(event: Event) {
        const clickedElement = event.currentTarget as HTMLButtonElement;

        const tabId = clickedElement.dataset.id;

        const tabElement = this.locationContents.find(
            (locationContent) => locationContent.dataset.id === tabId
        );

        if (!tabElement) {return;}

        if (this.activeContent) {
            this.activeContent.classList.remove('active-location');
            this.activeContent = tabElement;
        }

        tabElement.classList.add('active-location');

        if (this.activeTrigger && clickedElement) {
            this.activeTrigger.classList.remove('active-trigger');
            this.activeTrigger = clickedElement;
            this.activeTrigger.classList.add('active-trigger');
        }
    }
}
